import _ from 'lodash';
import React from 'react';
import {formValueSelector, submit} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';

import {MODALS, createTeam, fetchAllTeams} from 'ducks/teams';
import {storeDataInModal, selectModal} from 'ducks/modals';
import {composeActions} from 'ducks/common';

import {AddTeamDetailsForm, AddTeamPermissionsForm} from './components';

import './styles.css';

class AddTeamModal extends React.Component<any> {
  state = {
    showAddTeamPermissionsForm: false
  };

  submitFirstForm = () => {
    this.props.submit('addTeamDetails');
  };

  storeTeamDetails = () => {
    const {name, avatar, locations}: any =
      this.props.data.formTeamDetails || {};
    this.setState({showAddTeamPermissionsForm: true}, () =>
      this.props.storeDataInModal({
        modalName: MODALS.ADD_TEAM,
        data: {name, avatar, locations}
      })
    );
  };

  createTeam = () => {
    const {name, locations, avatar}: any =
      this.props.data.storedTeamDetails || {};
    const permissions = this.props.data.formTeamPermissions;

    let selectedLocations: Array<any> = [];
    let selectedPermissions: Array<any> = [];

    if (locations) {
      selectedLocations = _.keys(locations).filter(loc => locations[loc]);
    }
    if (permissions) {
      selectedPermissions = _.keys(permissions)
        .filter(p => permissions[p])
        .map(p => ({value: p}));
    }

    const data = {
      name,
      avatar,
      locations: selectedLocations,
      permissionEntities: selectedPermissions
    };

    this.props.composeActions([
      () =>
        storeDataInModal({
          modalName: MODALS.ADD_TEAM,
          data: {creatingTeam: true}
        }),
      () =>
        createTeam(data, [...this.props.closeModalExtraActions, fetchAllTeams]),
      () =>
        storeDataInModal({
          modalName: MODALS.ADD_TEAM,
          data: {creatingTeam: false}
        })
    ]);
  };

  render() {
    const {showAddTeamPermissionsForm} = this.state;
    const {creatingTeam} = this.props.data;

    const modalType = showAddTeamPermissionsForm
      ? Modal.MEDIUM
      : Modal.EXTRA_SMALL;

    return (
      <Modal
        className="AddTeamModal"
        type={modalType}
        show={true}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Add Team" />
        <Modal.Body>
          {!showAddTeamPermissionsForm && (
            <AddTeamDetailsForm onSubmit={this.storeTeamDetails} />
          )}
          {showAddTeamPermissionsForm && <AddTeamPermissionsForm />}
        </Modal.Body>
        <Modal.Footer>
          <Button white onClick={this.props.closeModal}>
            Cancel
          </Button>
          {!showAddTeamPermissionsForm && (
            <Button blue onClick={this.submitFirstForm}>
              Continue
            </Button>
          )}
          {showAddTeamPermissionsForm && (
            <Button
              white
              onClick={this.createTeam}
              isLoading={creatingTeam}
              disabled={creatingTeam}>
              Create team
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const detailsFormSelector = formValueSelector('addTeamDetails');
const permissionsFormSelector = formValueSelector('addTeamPermissions');

const mapStateToProps = state => {
  const storedTeamDetails = selectModal(state, MODALS.ADD_TEAM).data;
  const formTeamPermissions = permissionsFormSelector(state, 'permissions');

  return {
    storedTeamDetails,
    formTeamPermissions,
    formTeamDetails: {
      name: detailsFormSelector(state, 'teamName'),
      locations: detailsFormSelector(state, 'locations'),
      avatar: detailsFormSelector(state, 'avatar')
    }
  };
};

const mapDispatchToProps = {
  composeActions,
  submit,
  storeDataInModal
};

export default withModal(MODALS.ADD_TEAM, mapStateToProps, mapDispatchToProps)(
  AddTeamModal
);
